// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"233":"12d67e114414509e","343":"3d4a103c0c6cb9f8","355":"55a2efa5a72d565f","584":"cdc62d9b2554b04f","805":"abfcfe4180ff2f2a","807":"c3d8c71e8846547b","955":"4d1b4fec38ae865d","983":"1939c0fd989a2e6a"}[chunkId] + ".js";
};